import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatGridTileHeaderCssMatStyler } from "@angular/material";
import Helper from '../../core/utility/helper';
import { InfoButtonImage } from '../../models/infobutton-image';
import { ImageToBeDeleted } from '../../models/internal/image-tobe-deleted';
import { FileToBeUploaded } from '../../models/internal/file-tobe-uploaded';
import { InfoButtonDTO } from '../../models/internal/infobutton-dto';
import { InfoButtonImageToBeUploaded } from '../../models/internal/infobutton-image-uploaded';
import { DataService } from '../../services/data.service';
import { FormService } from '../../services/form';
import { LocalstorageService } from '../../services/localstorage.service';
import { ToastService } from '../../services/toaster/toaster.service';
import { log } from 'console';
import { InfoButtonDocument } from '../../models/infobutton-document';
import { FormFileToBeUploaded } from '../../models/internal/formfile-tobe-uploaded';
import { AppSettings } from '../../app.settings';
import { DocumentToBeDeleted } from '../../models/internal/document-tobe-deleted';

@Component({
  selector: 'app-info-button-edit',
  templateUrl: './info-button-edit.component.html',
  styleUrls: ['./info-button-edit.component.scss']
})
export class InfoButtonEditComponent implements OnInit {

  infoButtonDTO: InfoButtonDTO = new InfoButtonDTO();
  infoButtonForm: FormGroup;
  infoButtonImages: InfoButtonImage[] = [];
  infoButtonDocuments: InfoButtonDocument[] = [];
  public formErrors;
  @Output() private imageDeleteClicked: EventEmitter<
  ImageToBeDeleted
> = new EventEmitter<ImageToBeDeleted>();

  constructor(
    private dialogRef: MatDialogRef<InfoButtonEditComponent>,
    @Inject(MAT_DIALOG_DATA) public InfoButtonId: number,
    private fb: FormBuilder,
    private formService: FormService,
    private dataService: DataService,
    private toastService: ToastService,
    private appSettings: AppSettings,
    private localstorageService: LocalstorageService
  ) {

    this.InfoButtonId = InfoButtonId;
  }

  ngOnInit() {
    this.infoButtonForm = this.fb.group({
      CustomText: [null]
    });

    this.formErrors = {
      CustomText: ''
    };
    this.getInfoButton();
  }

  getInfoButton()
  {
    this.dataService
    .getInfoButton(this.InfoButtonId)
    .subscribe((response: any) => {
        if (response != null && response.Data != null) {
            this.infoButtonDTO = response.Data;
            this.setControlValues(this.infoButtonDTO);
          }
    });

  }
  

// uploadInfoButtonImage(infoButtonImageToBeUploaded: InfoButtonImageToBeUploaded) {
//   // debugger;
//   this.dataService
//       .uploadInfoButtonImage(
//         infoButtonImageToBeUploaded.File,
//         String(this.infoButtonData.Id)
//       )
//       .subscribe(response => {
//           if (response != null) {
//               const uploadedDoc: InfoButtonImage = {
//                   Id: response.Data.Id,
//                   UUId: response.Data.Url,
//                   InfoButtonId: +this.
//                   ProposalId: +this.proposalId,
//                   FileName: response.Data.FileName,
//                   Enabled: true,
//                   IsSelected: true,
//               };
//               // this.imageUploaded.emit(uploadedImage);
//               this.createProposalDTO.DefaultProposal.DocumentInfo.push(
//                   uploadedDoc
//               );
//               this.logDebug(this.createProposalDTO);
//               this.proposalimagesComponent.setControlValues(
//                   this.createProposalDTO
//               );
//           }
//       });
// }

  Save() {
    if(this.saveInfoButtonInformation(this.infoButtonDTO))
    {
      this.dialogRef.close();
    }
  }

  /**
   * TMS-15768 save due date extension
   */
  saveInfoButtonInformation(infoButtonDTO: InfoButtonDTO): boolean {
    this.infoButtonForm.updateValueAndValidity({emitEvent: false, onlySelf: false});
    this.validateForm();
    if (this.infoButtonForm.invalid) {
      // return false;
    }
    // const infoButtonDTO = new InfoButtonDTO();
    // infoButtonDTO.Id = infoButtonData.Id;
    infoButtonDTO.CustomText = this.infoButtonForm.controls['CustomText'].value;

    this.dataService.saveInfoButton(infoButtonDTO)
        .subscribe((response: any) => {
            if (response &&
                response.Data &&
                response.Success) {
                this.toastService.success(
                    'Saved info button information successfully.'
                );
            } else {
                this.toastService.error(
                    'Could not save info button information.'
                );
            }
        });
        return true;
  }

  infoButtonImageUploaded(imageToBeUploaded: FileToBeUploaded) {
    // debugger;
    // if only creating new and no
    const uploadedImage: InfoButtonImage = {
        Id: 0,
        UUId: imageToBeUploaded.File,
        InfoButtonId: +this.infoButtonDTO.Id,
        FileName: imageToBeUploaded.FileName,
        Enabled: true,
        IsSelected: true,
        DisplayUrl: ''
    };
    this.infoButtonDTO.ImageInfo.push(uploadedImage);
}

uploadDocument(docToBeUploaded: FileToBeUploaded) {
  // debugger;
  const uploadedDocument: InfoButtonImage = {
    Id: 0,
    UUId: docToBeUploaded.File,
    InfoButtonId: +this.infoButtonDTO.Id,
    FileName: docToBeUploaded.FileName,
    Enabled: true,
    IsSelected: true,
    DisplayUrl: ''
};
// this.imageUploaded.emit(uploadedImage);
this.infoButtonDTO.DocumentInfo.push(
    uploadedDocument
);
// don't save, let user click save button
}

deleteImage(imageToBeDeleted: ImageToBeDeleted) {
  if (imageToBeDeleted.Id != null && imageToBeDeleted.Id != undefined && imageToBeDeleted.Id != 0) {
      this.dataService
      .deleteInfoButtonImage(
          imageToBeDeleted.Id
      )
      .subscribe(response => {
          if (response != null) {
              const index = this.infoButtonDTO.ImageInfo.findIndex(x => x.Id == imageToBeDeleted.Id);
              if (index > -1) {
                  this.infoButtonDTO.ImageInfo.splice(index, 1);
              }
            console.log(this.infoButtonDTO);
          }
      });
  } else {
      const index = this.infoButtonDTO.ImageInfo.findIndex(x => x.UUId == imageToBeDeleted.Url && x.Id == imageToBeDeleted.Id);
      if (index > -1) {
          this.infoButtonDTO.ImageInfo.splice(index, 1);
      }
  }
}
deleteDocument(documentToBeDeleted: DocumentToBeDeleted) {
  if (documentToBeDeleted.Id != null && documentToBeDeleted.Id != undefined && documentToBeDeleted.Id != 0) {
      this.dataService
      .deleteInfoButtonDocument(
          documentToBeDeleted.Id
      )
      .subscribe(response => {
          if (response != null) {
              const index = this.infoButtonDTO.DocumentInfo.findIndex(x => x.Id == documentToBeDeleted.Id);
              if (index > -1) {
                  this.infoButtonDTO.DocumentInfo.splice(index, 1);
              }
            console.log(this.infoButtonDTO);
          }
      });
  } else {
      const index = this.infoButtonDTO.DocumentInfo.findIndex(x => x.UUId == documentToBeDeleted.Url && x.Id == documentToBeDeleted.Id);
      if (index > -1) {
          this.infoButtonDTO.DocumentInfo.splice(index, 1);
      }
  }
}
getImageURL(image: InfoButtonImage) {
      if (image.DisplayUrl == undefined || image.DisplayUrl == null || image.DisplayUrl === '') {
          return image.UUId;
      } else {
          return image.DisplayUrl;
      }
}

getInfoDocumentURL(doc: InfoButtonDocument) {
  return this.appSettings.Packaging2APIUrl +
  '/InfoButtonDocument/InfoButtonDocument/?InfoButtonDocumentId=' +
  doc.Id;
}
setControlValues(infoButtonDTO: InfoButtonDTO)
{
  this.infoButtonForm.controls['CustomText'].setValue(infoButtonDTO.CustomText);
  this.infoButtonImages = infoButtonDTO.ImageInfo;
  this.infoButtonDocuments = infoButtonDTO.DocumentInfo;
  this.infoButtonImages.forEach(x => {
    this.dataService.getInfoButtonImageFile(x).subscribe((y: any) => {
      if (y['Success'] == true) {
        let extension = String(y['Data']['FileName']).split('.');
        if (extension.length >= 2) {
            x.DisplayUrl = 'data:image/' + extension[extension.length - 1] + ';base64,' + y['Data']['Base64String'];
        } else {
            x.DisplayUrl = 'data:image/png' + ';base64,' + y['Data']['Base64String'];
        }
      }
    });
  });
}

validateForm() {
  Helper.resetFormErrors(this.formErrors);

  this.formErrors = this.formService.validateForm(
      <FormGroup>this.infoButtonForm,
      this.formErrors
  );
}

}
